import React, { useState, useEffect } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { getSummary } from '../../Utils/frontStageApi';
import { numAddComma } from '../../Utils/common';
import useMedia from '../../Utils/useMedia';

type StatisticType = {
  digitalCertificates: string;
  issuanceUnits: string;
  totalIssuances: string;
  totalVerifications: string;
};

type CardType = {
  number: string;
  text: string;
};

const Statistics: React.FC = () => {
  const { t } = useTranslation();
  const [statistic, setStatistic] = useState<StatisticType>();
  const { isDesktop } = useMedia();

  const DataCard: React.FC<CardType> = ({ number, text }) => (
    <Flex
      flex="1"
      minW="0"
      h="160px"
      direction="column"
      justify="center"
      align="center"
      gap="10px"
      bg="#FFF9D0"
      borderRadius="10px"
    >
      <Text
        fontFamily="Open Sans"
        fontWeight={700}
        fontSize="60px"
        lineHeight="100%"
        letterSpacing="0.01em"
        color="#00334D"
        textAlign="center"
      >
        {number}
      </Text>
      <Text
        fontFamily="Open Sans"
        fontWeight={600}
        fontSize="20px"
        lineHeight="120%"
        letterSpacing="0.01em"
        color="#00AAFF"
        textAlign="center"
      >
        {text}
      </Text>
    </Flex>
  );

  useEffect(() => {
    getSummary().then((summaryRes) => {
      setStatistic({
        digitalCertificates: summaryRes?.applied ? numAddComma(summaryRes.cat_num) : '0',
        issuanceUnits: summaryRes?.applied ? numAddComma(summaryRes.issuer_num) : '0',
        totalIssuances: summaryRes?.applied ? numAddComma(summaryRes.issued_cnt) : '0',
        totalVerifications: summaryRes?.applied ? numAddComma(summaryRes.verify_cnt) : '0',
      });
    });
  }, []);

  if (!statistic) return null;

  return (
    <Flex w="100%" maxW="1200px" direction="column" align="center">
      <Flex w="100%" direction={isDesktop ? 'row' : 'column'} align="stretch" gap="18px">
        <DataCard number={statistic.digitalCertificates} text={t('statistics.digitalCertificates')} />
        <DataCard number={statistic.issuanceUnits} text={t('statistics.certIssuanceUnits')} />
        <DataCard number={statistic.totalIssuances} text={t('statistics.totalIssuances')} />
        <DataCard number={statistic.totalVerifications} text={t('statistics.totalVerifications')} />
      </Flex>
    </Flex>
  );
};

export default Statistics;
